import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CALENDAR';

export const {action: shouldShowEventTypeSwitcher} = createAction(
    `${domain}/SHOULD_SHOW_EVENT_TYPE_SWITCHER`,
    show => ({show}),
);

export const {action: shouldShowCalendarSwitcher} = createAction(`${domain}/SHOULD_SHOW_CALENDAR_SWITCHER`, show => ({
    show,
}));

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const {action: resetAll} = createAction(`${domain}/RESET_ALL`, () => {});
